module.exports = __webpack_public_path__ + "static/media/bankgirot.3630d41b.svg";